import React, { useState } from "react";
import styles from "./BusinessEnquiry.module.css";
import {
  Form,
  Input,
  DatePicker,
  TimePicker,
  Button,
  message,
  Spin,
} from "antd";
import useWindowWidth from "helpers/useWindowWidth";
import moment from "moment";
import { API_BASE_URL } from "configs/AppConfig";
import MetaDetails from "components/meta-details/MetaDetails";
import SEO from "components/SEO/SEO";

function BusinessEnquiry() {
  const { TextArea } = Input;
  const width = useWindowWidth();
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const onFinish = async () => {
    try {
      // Validate all fields and retrieve their values
      const values = await form.validateFields();
  
      setLoading(true);
  
      // Transform specific fields if they exist
      if (values.activeVehiclesInOperation) {
        values.activeVehiclesInOperation = Number(values.activeVehiclesInOperation);
      }
  
      if (values.totalLabours) {
        values.totalLabours = Number(values.totalLabours);
      }
  
      if (values.numberOfBodyShops) {
        values.numberOfBodyShops = Number(values.numberOfBodyShops);
      }
  
      if (values.totalPartsSales) {
        values.totalPartsSales = Number(values.totalPartsSales);
      }
  
      if (values.preferableDate && values.preferableDate.format) {
        values.preferableDate = values.preferableDate.format("DD-MM-YYYY");
      }
  
      if (values.preferableTime) {
        values.preferableTime = moment(values.preferableTime, "HH:mm")?.format("h:mm A");
      }
  
      // Make the API request
      const response = await fetch(`${API_BASE_URL}business-enquiries/create/businessEnquiry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values), // Convert request body to JSON string
      });
  
      if (!response.ok) {
        // If response status is not OK, handle the error
        const errorData = await response.json();
        throw new Error(errorData.message || "Unknown error occurred");
      }
  
      const data = await response.json();
      console.log("Success:", data);
      message.success("Submitted Successfully");
      form.resetFields();
      setLoading(false);
    } catch (error) {
      // Handle validation or API errors
      console.error("Error:", error);
      message.error("Please Enter all Required Fields");
      setLoading(false);
    }
  };
  

  return (
    <>
    <SEO />
    <MetaDetails
        title={"Business Enquiry"}
        description={"Business Enquiry"}
        keywords={["business","enquiry"]?.join(', ')}
      />
    <div className="contact-uss">
      <div className={styles.businessOuter}>
        <h1
          className={styles.titleValue}
          data-aos="fade-right"
          data-aos-delay="200"
        >
          BUSINESS ENQUIRY
        </h1>
        <img
          className={styles.downArrow}
          data-aos="fade-right"
          data-aos-delay="200"
          src="/img/bodyshop/down-arrow.svg"
        />
        <main className={styles.formContainer}>
          <section className={styles.formSection}>
            <header className={styles.formHeader}>
              <p
                className={styles.subtitle}
                data-aos="fade-right"
                data-aos-delay="200"
              >
                TELL US ABOUT YOU
              </p>
              <h1
                data-aos="fade-right"
                data-aos-delay="200"
                className={styles.title}
              >
                Check Whether Your Body & Paint Business Qualifies for
                Consulting
              </h1>
              <div className={styles.arrowFlex}>
                <p
                  data-aos="fade-right"
                  data-aos-delay="200"
                  className={styles.description}
                >
                  Our team will contact you with a preliminary assessment upon
                  receiving the details.
                </p>
                <img
                  data-aos="fade-right"
                  data-aos-delay="200"
                  src="/img/bodyshop/blue-circle-arrow.svg"
                />
              </div>
            </header>
          </section>
          <div data-aos="fade-down" data-aos-delay="200" className={styles.formDiv}>
            <Form
              form={form}
              name="customerForm"
              // onFinish={onFinish}
              layout="vertical"
              className={styles.form}
            >
              <section className={styles.formSection}>
                <div className={styles.sectionContent}>
                  <h2 className={styles.sectionTitle}>Customer Information</h2>
                  <p className={styles.sectionDescription}>
                    Needed for communication and appointment scheduling.
                  </p>
                  <div className={styles.inputRow}>
                    <Form.Item
                      name="name"
                      label="First Name"
                      rules={[
                        {
                          required: true,
                          message: "Please input your first name!",
                        },
                      ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input placeholder="Name" className={styles.antInput} />
                    </Form.Item>
                    <Form.Item
                      name="lastName"
                      label="Last Name"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input your last name!",
                      //   },
                      // ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input
                        placeholder="Last Name"
                        className={styles.antInput}
                      />
                    </Form.Item>
                  </div>
                  <Form.Item
                    name="address"
                    label="Address"
                    // rules={[
                    //   { required: true, message: "Please input your address!" },
                    // ]}
                    style={{ width: width > 700 ? "100%" : "100%" }}
                  >
                    <Input.TextArea
                      rows={4}
                      placeholder="Address"
                      className={styles.antTextArea}
                    />
                  </Form.Item>
                  <div className={styles.inputRow}>
                    <Form.Item
                      name="email"
                      label="Email"
                      rules={[
                        { required: true, message: "Please input your email!" },
                        {
                          type: "email",
                          message: "Please enter a valid email!",
                        },
                      ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input
                        placeholder="Email"
                        type="email"
                        className={styles.antInput}
                      />
                    </Form.Item>
                    <Form.Item
                      name="phoneNumber"
                      label="Phone Number"
                      rules={[
                        {
                          required: true,
                          message: "Please input your phone number!",
                        },
                      ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input
                        placeholder="Phone Number"
                        type="tel"
                        className={styles.antInput}
                      />
                    </Form.Item>
                  </div>
                  <div className={styles.inputRow}>
                    <Form.Item
                      name="preferableDate"
                      label="Preferable Date"
                      // rules={[
                      //   { required: true, message: "Please select a date!" },
                      // ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        className={styles.antInput}
                      />
                    </Form.Item>
                    <Form.Item
                      name="preferableTime"
                      label="Preferable Time"
                      // rules={[
                      //   { required: true, message: "Please select a time!" },
                      // ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <TimePicker
                        style={{ width: "100%" }}
                        className={styles.antInput}
                      />
                    </Form.Item>
                  </div>
                  <Form.Item
                    name="message"
                    label="Message"
                    // rules={[
                    //   { required: true, message: "Please input your message!" },
                    // ]}
                    style={{ width: width > 700 ? "100%" : "100%" }}
                  >
                    <TextArea
                      rows={4}
                      placeholder="Your message"
                      className={styles.antTextArea}
                    />
                  </Form.Item>
                </div>
              </section>
              <section className={styles.formSection}>
                <div className={styles.sectionContent}>
                  <h2 className={styles.sectionTitle}>
                    Dealership and Business Details
                  </h2>
                  <p className={styles.sectionDescription}>
                    Essential for customized service and business analysis.
                  </p>
                  <div className={styles.inputRow}>
                    <Form.Item
                      name="dealershipBrand"
                      label="Dealership/Brand"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input your dealership/brand!",
                      //   },
                      // ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input
                        placeholder="Dealership/Brand"
                        className={styles.antInput}
                      />
                    </Form.Item>
                    <Form.Item
                      name="location"
                      label="Location"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input your location!",
                      //   },
                      // ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input
                        placeholder="Location"
                        className={styles.antInput}
                      />
                    </Form.Item>
                  </div>
                  <div className={styles.inputRow}>
                    <Form.Item
                      name="activeVehiclesInOperation"
                      label="Active Vehicles in Operation/UIO"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input active vehicles!",
                      //   },
                      // ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input
                        type="number"
                        placeholder="UIO"
                        className={styles.antInput}
                      />
                    </Form.Item>
                    {/* <Form.Item
                    name="bodyshopRO"
                    label="Bodyshop RO/Month"
                    rules={[
                      {
                        required: true,
                        message: "Please input bodyshop RO/Month!",
                      },
                    ]}
                    style={{ width: width > 700 ? "50%" : "100%" }}
                  >
                    <Input
                      placeholder="BODYSHOP RO/MONTH"
                      className={styles.antInput}
                    />
                  </Form.Item> */}
                    <Form.Item
                      name="totalLabours"
                      label="Total Labor Sales/Month"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input total labor sales!",
                      //   },
                      // ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input
                        placeholder="TOTAL LABOR SALES/MONTH"
                        className={styles.antInput}
                        type="number"
                      />
                    </Form.Item>
                  </div>
                  <div className={styles.inputRow}>
                    <Form.Item
                      name="totalPartsSales"
                      label="Total Parts Sales/Month"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input total parts sales!",
                      //   },
                      // ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input
                        placeholder="TOTAL PARTS SALES/MONTH"
                        className={styles.antInput}
                        type="number"
                      />
                    </Form.Item>
                    <Form.Item
                      name="numberOfBodyShops"
                      label="Number of Bodyshop Bays"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input number of bodyshop bays!",
                      //   },
                      // ]}
                      style={{ width: width > 700 ? "50%" : "100%" }}
                    >
                      <Input
                        placeholder="Number of Bodyshop Bays"
                        className={styles.antInput}
                        type="number"
                      />
                    </Form.Item>
                  </div>
                </div>
              </section>
              <Form.Item>
                <button onClick={onFinish} type="submit" className={styles.submitButton}>
                  {loading ? <Spin size="large" /> : "Send Message"}
                </button>
              </Form.Item>
            </Form>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}

export default BusinessEnquiry;
